const SCALE_LIMITS = {
  tshirt: { min: 0.5, max: 1.5, step: 0.01 },

  mug: { min: 0.2, max: 1.1, step: 0.01 },

  coffee: { min: 0.2, max: 1.0, step: 0.01 },

  tumbler: { min: 0.25, max: 1.2, step: 0.01 },

  box: { min: 0.35, max: 2.0, step: 0.01 },
};

/* ===================================================== */

export default function ScaleSlider({ scale, setScale, product }) {
  const limits = SCALE_LIMITS[product] ?? SCALE_LIMITS.tshirt;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function handleChange(rawValue) {
    const value = parseFloat(rawValue);

    const safeValue = clamp(value, limits.min, limits.max);

    setScale(safeValue);
  }

  return (
    <div className='flex flex-col gap-4'>
      <Label>Scale</Label>

      <div className='flex items-center gap-3'>
        <input
          type='range'
          min={limits.min}
          max={limits.max}
          step={limits.step}
          value={scale}
          onChange={(e) => handleChange(e.target.value)}
          className='
            flex-1
            h-[3px]
            bg-[#E7E2D9]
            rounded-full
            appearance-none
            cursor-pointer
            accent-[#C6A75E]
          '
        />

        <span
          className='
            w-12
            text-[11px]
            font-medium
            text-[#1F1F1F]
            text-right
            tabular-nums
          '
        >
          {scale.toFixed(2)}
        </span>
      </div>
    </div>
  );
}

/* ===================================================== */

function Label({ children }) {
  return (
    <div
      className='
        text-[11px]
        font-semibold
        text-[#8A867F]
        uppercase
        tracking-widest
      '
    >
      {children}
    </div>
  );
}
